(ns bec-cljs-common.logging
  (:require [goog.object :as gobject]
            [taoensso.timbre :as timbre]
            [clojure.string :as str]
            [bec-data-format.core :as bec-df]))


(defn- force-log-data [data]
  (->> data
       (map (fn [[key value]]
              [key (if (instance? Delay value)
                     (force value)
                     value)]))
       (into {})))


(defn configure-logging [server-address client-name]
  (timbre/merge-config!
   {:min-level :trace
    :appenders
    {:console
     {:enabled? goog.DEBUG, :min-level :trace
      :output-fn #(binding [cljs.pprint/*print-right-margin* 130
                            cljs.pprint/*print-miser-width* 100]
                    (cljs.pprint/with-pprint-dispatch cljs.pprint/code-dispatch
                      (with-out-str
                        (print (str/upper-case (name (:level %))) " ")
                        (cljs.pprint/pprint (:vargs %)))))}

     ::server-logger ;; Send log events to server.
     {:enabled? true, :min-level :info, :async? false, :output-fn :inherit
      ;; NOTE: It is crucial that this thing *never* throws any exception.
      :fn (fn [data]
            (letfn [(amend-data [data]
                      (-> data
                          (dissoc :appender :appender-id :config :output-fn :?err_ :output_ :msg_)
                          force-log-data
                          (update :?ns-str #(if (clojure.string/starts-with? % client-name)
                                              %
                                              (str client-name " | " %)))
                          (assoc :hostname (.-host (.-location js/window))
                                 :client-type client-name)))

                    (save-log! [data]
                      (let [data (amend-data data)]
                        (js/fetch (str server-address "/save-log") ;; TODO: Generalize; callback.
                                  #js {:method "POST", :body (bec-df/pack data)})))

                    (save-log-raw! [data e] ;; When all else fails, try to send log event as raw string.
                      (let [data (-> (amend-data data)
                                     (assoc ::exception-while-encoding e))]
                        (js/fetch (str server-address "/save-log-raw") ;; TODO: Generalize; callback.
                                  ;; TODO: Hmmm, use print-str with *print-length*, *print-level*, etc. bound?
                                  #js {:method "POST", :body (str data)})))]
              (try
                (if-let [err (:?err data)]
                  (if (instance? js/Error err)
                    (do
                      (when-not (.-stack err)
                        (. js/Error captureStackTrace err)) ;; TODO: V8 only!
                      ;; NOTE: stacktrace-js lib is used here: https://gitlab.com/bulls-eye/bec-cljs-common/-/issues/1
                      (-> (js/StackTrace.fromError err) ;; NOTE: This is why I can't move this to bec-data-format. Crazy..
                          (.then (fn [stacktrace]
                                   (-> (assoc data :?err {:name (.-name err), :message (.-message err)
                                                          :stacktrace stacktrace, :data (.-data err)})
                                       (save-log!))))
                          (.catch #(save-log-raw! data %))))
                    (-> (force-log-data data) ;; Failsafe; we got to do this because the server expects js/Error.
                        (update :vargs conj (:?err data))
                        (dissoc :?err)
                        (save-log!)))
                  (save-log! data))
                (catch :default e
                  (try
                    (save-log-raw! data e)
                    (catch :default e
                      ;; At this point we cannot do anything interesting; I'm not even sure printing out `e` is a good idea.
                      (println "Failed during logging; not good!" \newline e)))))))}}})

  (set! (.-onerror js/window)
        (fn [message source lineno colno error]
          (timbre/-log! timbre/*config*
                        :fatal
                        (str client-name ".%%bec-browser-global%%")
                        source
                        (str lineno ":" colno)
                        :p ;; msg-type
                        error ;; :?err
                        (delay [message source (str lineno ":" colno)]) ;; :vargs
                        nil)
          true)))
